import React, { Children, MouseEventHandler, PropsWithChildren } from 'react'
import classNames from 'classnames/bind'

import Style from './FloatingButton.module.scss'

const cx = classNames.bind(Style)

type Props = {
  label: string
  disabled?: boolean
  onClick: MouseEventHandler<HTMLButtonElement>
}
const GreenButton = ({ label, onClick, disabled = false }: Props) => {
  return (
    <button type="button" className={cx('button-action', 'type-green', { disabled })} onClick={onClick}>
      {label}
    </button>
  )
}
const GrayButton = ({ label, onClick }: Props) => {
  return (
    <button type="button" className={cx('button-action', 'type-gray')} onClick={onClick}>
      {label}
    </button>
  )
}

const FloatingButton = ({ children }: PropsWithChildren<unknown>) => {
  return (
    <div className={cx('article')}>
      <div className={cx('area-button')}>
        {Children.toArray(children).map((button, index) => (
          <div key={index} className={cx('cell')}>
            {button}
          </div>
        ))}
      </div>
    </div>
  )
}

FloatingButton.GreenButton = GreenButton
FloatingButton.GrayButton = GrayButton

export default FloatingButton
